import { CrownFilled } from "@ant-design/icons";
import { Tag } from "antd";
import { isDatasetGolden } from "common/goldenNominal";
import { useAppSelector } from "hooks";

interface IProps {
    schemaId?: string;
    dataSetId?: string;
    schemaName?: string;
    // Backend flag on the loaded dataset; combined with any in-session override.
    isGoldenNominal?: boolean;
}

// Gold banner shown at the top of the Dataset detail when this dataset is the
// nominated Golden Nominal for its schema.
export default function DatasetGoldenNominalBanner({ schemaId, dataSetId, schemaName, isGoldenNominal }: IProps) {
    const goldenBySchema = useAppSelector((s) => s.goldenNominal?.goldenBySchema);
    const isGolden = !!schemaId && !!dataSetId && isDatasetGolden(goldenBySchema, schemaId, dataSetId, isGoldenNominal);

    if (!isGolden) {
        return null;
    }

    return (
        <div className="flex flex-wrap items-center justify-between gap-2 rounded-md border border-amber-300 bg-amber-50 px-4 py-2" data-testid="golden-nominal-banner">
            <div className="flex flex-wrap items-center gap-2 text-sm text-amber-800">
                <CrownFilled className="text-amber-500" />
                <span className="font-semibold uppercase tracking-wide">Golden Nominal Dataset</span>
                <span className="text-amber-700">
                    — This dataset is the nominated authority for the <span className="font-semibold">{schemaName || "this"}</span> schema. It is the survivorship source and persistence
                    reference in all downstream journeys.
                </span>
            </div>
            <Tag color="green" className="!m-0" data-testid="golden-nominal-active-tag">
                ACTIVE
            </Tag>
        </div>
    );
}
